import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

const ToastContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

interface WatchlistErrorToastContentProps {
  isRemoving: boolean
  // True when this error is for a failed undo-restore (re-creating a
  // just-deleted record), not a plain add. Takes precedence over isRemoving.
  isUndoRestore?: boolean
}

/**
 * Toast content component for watchlist error notifications
 *
 * Features:
 * - Shows error message when watchlist add/remove/undo-restore operations fail
 * - Conditional messaging based on operation type (add vs remove vs undo)
 * - Close button handled by react-toastify configuration
 * - Follows established error toast patterns from TermsRestrictions
 */
const WatchlistErrorToastContent = ({
  isRemoving,
  isUndoRestore,
}: WatchlistErrorToastContentProps) => {
  const messageId = isUndoRestore
    ? 'Listing.watchlist.undoErrorText'
    : isRemoving
      ? 'Listing.watchlist.removeErrorText'
      : 'Listing.watchlist.addErrorText'

  return (
    <ToastContainer>
      <span>
        <FormattedMessage id={messageId} />
      </span>
    </ToastContainer>
  )
}

export default WatchlistErrorToastContent
